import { useField } from 'formik';

import { Textarea } from '../Textarea/Textarea';

export const FormikTextArea = (props) => {
    const [field] = useField(props);

    return <Textarea {...props} {...field} />;
};
